import * as Reflux from "reflux";
export const SurveyActions = {
	onSubmitSurvey: Reflux.createAction(["onSubmitSurvey"]),
	onCommentChange: Reflux.createAction(["onCommentChange"]),
	onSetRating: Reflux.createAction(["onSetRating"]),
	onReasonSelection: Reflux.createAction(["onReasonSelection"]),
	onNewSurvey: Reflux.createAction(["onNewSurvey"]),
	onSendCustomerDataChange: Reflux.createAction(["onSendCustomerDataChange"]),
	onNextStep: Reflux.createAction(["onNextStep"]),
	onSubmitProbeSurvey: Reflux.createAction(["onSubmitProbeSurvey"]),
};
